import React from "react";
import { Button } from "react-bootstrap";

const SubmissionThankYouPage = ({ setIsFormSubmitted }) => {
  return (
    <div className="thank-you-submission-container">
      <div className="submission-sign">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-check2-circle"
          viewBox="0 0 16 16"
        >
          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
        </svg>
      </div>
      <div className="submission-message">
        <h3 className="sub-msg">Your submission is received</h3>
      </div>
      <div className="submission-back-btn">
        <Button
          className="saveBtn"
          variant="danger"
          type="button"
          onClick={() => setIsFormSubmitted(false)}
        >
          Submit New Form
        </Button>
      </div>
    </div>
  );
};

export default SubmissionThankYouPage;
